<ca-conversation-standart-email-list
  *ngIf="standardListVisible"
  (conversationIdChange)="onConversationIdChanged($event)"
  (dataLoaded)="onDataLoaded()">
</ca-conversation-standart-email-list>
